import { ApiResponse, PaginatedApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import {
  IServiceRequest,
  ServiceRequestsListResponse,
  ServiceRequestListQueryParams,
  ServiceRequestUpdateData,
} from "@/types/service-request-management.types";

export const ServiceRequestManagementService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getServiceRequests: builder.query<
      PaginatedApiResponse<IServiceRequest[]>,
      ServiceRequestListQueryParams
    >({
      query: (params) => ({
        url: "/service-requests",
        method: "GET",
        params,
      }),
      transformResponse: (response: ServiceRequestsListResponse) => ({
        data: response.data,
        totalItems: response.totalItems,
        totalPages: response.totalPages,
        currentPage: response.page,
        status: response.status,
        message: response.message,
      }),
      providesTags: ["ServiceRequests"],
      keepUnusedDataFor: 0,
    }),

    updateServiceRequest: builder.mutation<
      ApiResponse<IServiceRequest>,
      { id: string; data: ServiceRequestUpdateData; harborId?: string }
    >({
      query: ({ id, data, harborId }) => ({
        url: harborId
          ? `/service-requests/${id}?harbor_id=${harborId}`
          : `/service-requests/${id}`,
        method: "PATCH",
        data: data,
      }),
      invalidatesTags: ["ServiceRequests"],
    }),

    approveAndCreateService: builder.mutation<
      ApiResponse<unknown>,
      { id: string; data: FormData; harborId?: string }
    >({
      query: ({ id, data, harborId }) => ({
        url: harborId
          ? `/service-requests/${id}/approve-and-create?harbor_id=${harborId}`
          : `/service-requests/${id}/approve-and-create`,
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
      invalidatesTags: ["ServiceRequests", "Services"],
    }),

    updateServiceRequestStatus: builder.mutation<
      ApiResponse<IServiceRequest>,
      { id: string; data: { status: string; reason?: string }; harborId?: string }
    >({
      query: ({ id, data, harborId }) => ({
        url: harborId
          ? `/service-requests/${id}/status?harbor_id=${harborId}`
          : `/service-requests/${id}/status`,
        method: "PATCH",
        data: data,
      }),
      invalidatesTags: ["ServiceRequests"],
    }),
  }),
});

export const {
  useGetServiceRequestsQuery,
  useUpdateServiceRequestMutation,
  useApproveAndCreateServiceMutation,
  useUpdateServiceRequestStatusMutation,
} = ServiceRequestManagementService;
